import { takeEvery, put, call, select } from 'redux-saga/effects'
import moment from 'utils/momentInstanse'
import api from 'api'

import {
  setFacilityData,
  setError,
  getFacility,
  setIsFetchingFacility,
  getCurrentFacilityData,
  setCurrentFacilityData,
  setSelectedDateRange,
  getFacilityIdSelector,
  setLastUpdateDate,
  setIsFetchingChartAreaData,
  getPerfomanceData,
  setPerfomanceDate,
  setIsFetchingPerfomance,
  getFacilityDateRangeSelector,
  getHeatMapData,
  setHeatMapData,
  setIsFetchingHeatMap,
  getHeatmapSelectedTimeStampSelector,
  setHeatmapTimestamp,
} from 'redux/reducers/facility'
import {setIsRedirect} from '../reducers/isRedirectForPages'

function* getFacilitySagaWorker({ payload }) {
  try {
    yield put(setIsFetchingFacility(true))
    // const facilityId = yield select(getFacilityIdSelector)
    const { data } = yield call([api.facility, 'getFacility'], payload)
    //const mapperResponse = simpleFacilityMapper(response)
    yield put(setFacilityData(data.body))
    if(data.body === 'Invalid request body, path or querystring params') {
      throw new Error()
    }
  } catch (error) {
    yield put(
      setError({
        code: error?.code,
        message: error?.message,
      })
    )
    yield put(setIsRedirect(true))
  } finally {
    yield put(setIsFetchingFacility(false))
  }
}

function* getPerfomanceDataWorker({ payload }) {
  try {
    yield put(setIsFetchingPerfomance(true))

    const timestamp = moment.utc().unix()

    const response = yield call(
      [api.facility, 'getFacilityPerfomanceData'],
      payload,
      { timestamp }
    )
    const { data } = response
    yield put(setPerfomanceDate(data?.body))
  } catch (error) {
    /// errror
  } finally {
    yield put(setIsFetchingPerfomance(false))
  }
}

function* getFacilityTotalDataSagaWorker(action) {
  try {
    yield put(setIsFetchingChartAreaData(true))
    const facilityId = yield select(getFacilityIdSelector)
    const dataRangeParams = yield select(getFacilityDateRangeSelector)

    const res = yield call(
      [api.facility, 'getCurrentFacilityData'],
      facilityId,
      action.payload?.value || dataRangeParams?.value
    )

    const { data, headers } = res
    yield put(setCurrentFacilityData(data?.body))
    yield put(setLastUpdateDate(headers?.date || null))
  } catch (error) {
    yield put(
      setError({
        code: error?.code,
        message: error?.message,
      })
    )
  } finally {
    yield put(setIsFetchingChartAreaData(false))
  }
}

function* getHeatMapDataSagaWorker() {
  try {
    yield put(setIsFetchingHeatMap(true))
    const facilityId = yield select(getFacilityIdSelector)
    const timestamp = yield select(getHeatmapSelectedTimeStampSelector)

    const { data } = yield call([api.facility, 'getHeatMatData'], facilityId, {
      timestamp,
    })

    yield put(setHeatMapData(data?.body?.heatmap || data?.body))
  } catch (error) {
    // to do
  } finally {
    yield put(setIsFetchingHeatMap(false))
  }
}

export default function* facilitySagaWatcher() {
  yield takeEvery(getFacility.type, getFacilitySagaWorker)
  yield takeEvery(
    [getCurrentFacilityData.type, setSelectedDateRange.type],
    getFacilityTotalDataSagaWorker
  )
  yield takeEvery(getPerfomanceData.type, getPerfomanceDataWorker)
  yield takeEvery(
    [getHeatMapData.type, setHeatmapTimestamp.type],
    getHeatMapDataSagaWorker
  )
}
